import { Select } from "@planningcenter/doxy-web"
import React from "react"
import {
  MONTH_DAY_LABELS,
  TWICE_MONTHLY_LABELS,
  WEEK_DAY_LABELS,
} from "../constants"
import {
  DateStampString,
  MonthDayNumber,
  TwiceMonthlyDays,
  WeekDayNumber,
} from "../types"
import { dateStampStringToLocal } from "../utils/frequency"

type DaySelectorProps = {
  value: MonthDayNumber
  onDayChange: (day: MonthDayNumber) => void
}
export function DaySelector({ value, onDayChange }: DaySelectorProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onDayChange(Number(e.target.value) as MonthDayNumber)
  }

  return (
    <Select
      id="donation-recurrence-day"
      value={value.toString()}
      onChange={handleChange}
    >
      {Object.entries(MONTH_DAY_LABELS).map(([dayNum, label]) => (
        <Select.Option key={dayNum} value={dayNum} label={label} />
      ))}
    </Select>
  )
}

type WeekDaySelectorProps = {
  value: WeekDayNumber
  onWeekDayChange: (day: WeekDayNumber) => void
}
export function WeekDaySelector({
  value,
  onWeekDayChange,
}: WeekDaySelectorProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onWeekDayChange(Number(e.target.value) as WeekDayNumber)
  }

  return (
    <Select
      id="donation-recurrence-weekday"
      value={value.toString()}
      onChange={handleChange}
    >
      {Object.entries(WEEK_DAY_LABELS).map(([dayNum, label]) => (
        <Select.Option key={dayNum} value={dayNum} label={label} />
      ))}
    </Select>
  )
}

type TwiceMonthlySelectorProps = {
  value: TwiceMonthlyDays
  onDaysChange: (day: TwiceMonthlyDays) => void
}
export function TwiceMonthlySelector({
  value,
  onDaysChange,
}: TwiceMonthlySelectorProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onDaysChange(e.target.value as TwiceMonthlyDays)
  }

  return (
    <Select
      id="donation-recurrence-twice-monthly"
      value={value}
      onChange={handleChange}
    >
      {Object.entries(TWICE_MONTHLY_LABELS).map(([dayNum, label]) => (
        <Select.Option key={dayNum} value={dayNum} label={label} />
      ))}
    </Select>
  )
}

type StartingSelectorProps = {
  options: DateStampString[]
  value: DateStampString
  onDateChange: (date: DateStampString) => void
  isLoading?: boolean
}
export function StartingSelector({
  options,
  value,
  onDateChange,
  isLoading = false,
}: StartingSelectorProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onDateChange(e.target.value as DateStampString)
  }

  const selectOptions: React.ReactElement<typeof Select.Option>[] = options.map(
    (option) => (
      <Select.Option
        key={option}
        value={option}
        label={dateStampStringToLocal(option)}
      />
    ),
  )

  if (isLoading) {
    selectOptions.unshift(
      <Select.Option key="loading" label={"Loading..."} value="" />,
    )
  }

  return (
    <Select
      id="donation-recurrence-start-date"
      value={value}
      onChange={handleChange}
      disabled={isLoading && options.length === 0}
    >
      {selectOptions}
    </Select>
  )
}
